import React from "react";
import { Pagination } from "react-bootstrap";

const CustomPagination = ({ totalPages, currentPage, onPageChange }) => {
  if (totalPages <= 1) return null;

  const pageItems = [];
  const maxVisible = 5;

  const addPage = (page) => {
    pageItems.push(
      <Pagination.Item
        key={page}
        active={currentPage === page}
        onClick={() => onPageChange(page)}
        className="page-circle"
      >
        {page}
      </Pagination.Item>
    );
  };

  if (totalPages <= maxVisible) {
    for (let i = 1; i <= totalPages; i++) addPage(i);
  } else {
    addPage(1);

    if (currentPage > 3) {
      pageItems.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);
    for (let i = start; i <= end; i++) addPage(i);

    if (currentPage < totalPages - 2) {
      pageItems.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
    }

    addPage(totalPages);
  }

  return (
    <div className="pagination-wrapper">
      <Pagination className="justify-content-center gap-2 clean-pagination">
        <Pagination.First
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
        >
          «
        </Pagination.First>
        <Pagination.Prev
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          ‹
        </Pagination.Prev>

        {pageItems}

        <Pagination.Next
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          ›
        </Pagination.Next>
        <Pagination.Last
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
        >
          »
        </Pagination.Last>
      </Pagination>
    </div>
  );
};

export default CustomPagination;
